import { render, staticRenderFns } from "./address.vue?vue&type=template&id=3cdbbd2f&"
import script from "./address.js?vue&type=script&lang=js&"
export * from "./address.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cdbbd2f')) {
      api.createRecord('3cdbbd2f', component.options)
    } else {
      api.reload('3cdbbd2f', component.options)
    }
    module.hot.accept("./address.vue?vue&type=template&id=3cdbbd2f&", function () {
      api.rerender('3cdbbd2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/address/address.vue"
export default component.exports